import type { RemovableRef } from "@vueuse/core"
import type { Test } from "@/components/TestHarness/useTestHarnessRunner"
import { useLocalStorage } from "@vueuse/core"
import { defineStore } from "pinia"

interface State {
  tests: RemovableRef<Test[]>
}

export const useTestHarnessStore = defineStore("testHarness", {
  state: (): State => ({
    tests: useLocalStorage<Test[]>("testHarness-tests", [])
  }),
  actions: {
    setTests(newTests: Test[]) {
      this.tests = newTests
    },
    addTest(test: Test) {
      this.tests.unshift(test)
    },
    updateTest(id: string, test: Partial<Test>) {
      const index = this.tests.findIndex((t) => t.id === id)
      if (index !== -1) {
        this.tests[index] = { ...this.tests[index], ...test }
      }
    },
    deleteTest(id: string) {
      const index = this.tests.findIndex((t) => t.id === id)
      if (index !== -1) {
        this.tests.splice(index, 1)
      }
    },
    clearTests() {
      this.tests = []
    },
  },
})
